import { Select, Label, SelectProps } from "flowbite-react";
import { forwardRef } from "react";
import { HiPlus } from "react-icons/hi";

interface CustomSelectProps extends SelectProps {
  id?: string;
  label: string;
  options: { value: string; label: string }[];
  error?: string;
  onAddClick?: () => void;
}

const CustomSelect = forwardRef<HTMLSelectElement, CustomSelectProps>(
  ({ id, label, options = [], error, onAddClick, ...props }, ref) => {
    return (
      <div className="mb-4">
        <div className="flex justify-between items-center mb-2">
            <Label htmlFor={id}>{label}</Label>
            {onAddClick && (
                <button
                    type="button"
                    onClick={onAddClick}
                    className="w-6 h-6 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-500 dark:text-gray-400 transition-colors"
                    title={`Create new ${label}`}
                >
                    <HiPlus className="w-4 h-4" />
                </button>
            )}
        </div>
        <Select id={id} ref={ref} {...props}>
          <option value="" disabled>
            Select {label.toLowerCase()}
          </option>
          {options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
        {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
      </div>
    );
  },
);

CustomSelect.displayName = "CustomSelect";

export default CustomSelect;
